<template>
  <v-dialog fullscreen v-model="visible" scrollable>
    <v-card style="position: relative; height: 100vh">
      <v-system-bar window dark color="primary">
        <v-icon>mdi-pencil-box-multiple</v-icon>
        <span>Content für: {{ selectedStudio.name }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-system-bar>

      <v-card-text style="padding-top: 20px; padding-bottom: 80px">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="mb-5" outlined>
                <v-card-title>Header Video</v-card-title>
                <v-card-text>
                  <v-responsive aspect-ratio="16/9" v-if="studioContent.headerVideo">
                    <div class="video-container">
                      <video :key="videoKey" autoplay loop muted playsinline>
                        <source
                          :src="`${linkPreview}/api/website/video/${studioContent.headerVideo.replace('.mp4', '-original.mp4')}`"
                          type="video/mp4" />
                        Dein Browser unterstützt das Video-Tag nicht.
                      </video>
                    </div>
                  </v-responsive>
                  <v-alert v-else type="info" class="mt-3"> Es ist noch kein Video hochgeladen. </v-alert>
                  <v-file-input
                    v-model="videoFile"
                    label="Neues Video hochladen"
                    accept="video/mp4"
                    prepend-icon="mdi-video-plus"
                    class="mt-4"></v-file-input>
                  <div v-if="processingVideo" class="text-center mt-3">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    <p class="mt-2">Video wird verarbeitet, bitte warten...</p>
                  </div>
                </v-card-text>
              </v-card>

              <v-card outlined>
                <v-card-title>Club Infos</v-card-title>
                <v-card-text>
                  <v-textarea
                    label="Club Beschreibungstext"
                    filled
                    auto-grow
                    placeholder="Willkommen im well come FIT..."
                    v-model="studioContent.clubSection.text"
                    rows="8"></v-textarea>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title>Bildergalerie</v-card-title>
                <v-card-text>
                  <div class="pa-3 mb-4" style="border: 2px dashed #444; border-radius: 8px">
                    <v-file-input
                      v-model="imageFiles"
                      label="Mehrere Bilder auswählen"
                      @change="onFilesSelected"
                      multiple
                      accept="image/*"
                      prepend-icon="mdi-image-multiple-outline"></v-file-input>

                    <v-card v-if="uploadItems.length > 0" class="mt-4" flat color="transparent">
                      <div v-for="(item, index) in uploadItems" :key="index" class="d-flex align-center mb-3">
                        <v-img :src="item.preview" aspect-ratio="1" class="rounded mr-3" width="60" height="60"></v-img>
                        <v-text-field v-model="item.alt" label="Alt-Text (SEO)" dense hide-details></v-text-field>
                        <v-btn icon small @click="removeUploadItem(index)" class="ml-2"><v-icon color="grey">mdi-close-circle</v-icon></v-btn>
                      </div>
                      <v-btn color="primary" block @click="uploadImages" :loading="isUploadingImages" :disabled="areUploadItemsInvalid">
                        {{ uploadItems.length }} Bild(er) hochladen
                      </v-btn>
                    </v-card>
                  </div>

                  <draggable v-model="studioContent.clubSection.pictures" handle=".drag-handle" ghost-class="ghost">
                    <transition-group type="transition" name="flip-list">
                      <v-card v-for="(picture, index) in studioContent.clubSection.pictures" :key="picture.src" class="mb-3 pa-2" outlined>
                        <v-row align="center" no-gutters>
                          <v-col cols="auto">
                            <v-icon class="drag-handle" style="cursor: move">mdi-drag-horizontal</v-icon>
                          </v-col>
                          <v-col cols="3">
                            <v-img
                              :src="`${linkPreview}/api/website/image/${picture.src}`"
                              :alt="picture.alt"
                              aspect-ratio="1"
                              class="rounded"></v-img>
                          </v-col>
                          <v-col class="pl-3">
                            <v-text-field v-model="picture.alt" label="Alt Text" dense hide-details></v-text-field>
                          </v-col>
                          <v-col cols="auto">
                            <v-btn icon color="red" @click="removePicture(index)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </transition-group>
                  </draggable>
                  <v-alert v-if="!studioContent.clubSection.pictures || studioContent.clubSection.pictures.length === 0" type="info">
                    Die Galerie ist leer.
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="d-flex justify-center" style="position: absolute; bottom: 0; width: 100%; background-color: #1e1e1e; padding: 15px 0">
        <v-btn text @click="closeDialog" class="mr-5 white--text">Abbrechen</v-btn>
        <v-btn color="primary" large @click="saveContent" :loading="isSaving">
          <v-icon left>mdi-check-circle</v-icon>
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"
import draggable from "vuedraggable"

export default {
  components: { draggable },
  props: {
    selectedStudio: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
      studioContent: {
        clubSection: { pictures: [] },
      },
      videoFile: null,
      imageFiles: [], // NEU: Hält die Auswahl aus dem file-input
      uploadItems: [], // NEU: Hält die Bilder und ihre Alt-Texte vor dem Upload
      videoKey: Date.now(),
      processingVideo: false,
      isUploadingImages: false, // Geändert von isUploadingImage
      isSaving: false,
    }
  },
  computed: {
    linkPreview() {
      let previewUrl = window.location.href.includes("local") ? "https://app.wellcomefit.ch" : ""

      return previewUrl
    },
    // NEU: Prüft, ob alle ausgewählten Bilder einen Alt-Text haben
    areUploadItemsInvalid() {
      if (this.uploadItems.length === 0) return true
      return false
      return this.uploadItems.some((item) => !item.alt || item.alt.trim() === "")
    },
  },
  watch: {
    selectedStudio: {
      immediate: true,
      handler() {
        this.loadContent()
      },
    },
    videoFile(newFile) {
      if (newFile) {
        this.uploadVideo()
      }
    },
  },
  methods: {
    closeDialog() {
      this.visible = false
      this.$emit("close-dialog")
    },
    async loadContent() {
      try {
        const { result } = await api.fetchWebsiteContent(this.selectedStudio.code)
        if (result) {
          this.studioContent = result
          if (!this.studioContent.clubSection) {
            this.$set(this.studioContent, "clubSection", { text: "", pictures: [] })
          }
          if (!this.studioContent.clubSection.pictures) {
            this.$set(this.studioContent.clubSection, "pictures", [])
          }
        } else {
          this.studioContent = this.initNewContent()
        }
      } catch (e) {
        this.$toast.error("Fehler beim Laden des Inhalts")
      }
    },
    initNewContent() {
      return {
        studio: this.selectedStudio._id,
        headerVideo: null,
        clubSection: {
          text: "",
          pictures: [],
        },
      }
    },
    async saveContent() {
      this.isSaving = true
      try {
        await api.updateWebsiteContent(this.studioContent)
        this.$toast.success("Inhalt erfolgreich gespeichert!")
        this.closeDialog()
      } catch (e) {
        this.$toast.error("Fehler beim Speichern des Inhalts.")
      } finally {
        this.isSaving = false
      }
    },
    async uploadVideo() {
      if (!this.videoFile) return
      this.processingVideo = true
      const formData = new FormData()
      formData.append("video", this.videoFile)
      try {
        const response = await api.uploadWebsiteVideo(formData)
        if (response.file) {
          this.studioContent.headerVideo = response.file
          this.videoKey = Date.now()
          this.$toast.success("Video erfolgreich hochgeladen")
        }
      } catch (error) {
        this.$toast.error("Fehler beim Hochladen des Videos")
      } finally {
        this.processingVideo = false
        this.videoFile = null
      }
    },
    // NEU: Erstellt die Vorschau-Liste, wenn Dateien ausgewählt werden
    onFilesSelected() {
      this.uploadItems = this.imageFiles.map((file) => ({
        file: file,
        alt: "",
        preview: URL.createObjectURL(file),
      }))
    },
    // NEU: Entfernt ein Bild aus der Upload-Vorschau
    removeUploadItem(index) {
      this.uploadItems.splice(index, 1)
      this.imageFiles.splice(index, 1)
    },
    // NEU: Lädt alle Bilder aus der Vorschau hoch
    async uploadImages() {
      this.isUploadingImages = true
      for (const item of this.uploadItems) {
        const formData = new FormData()
        formData.append("image", item.file)
        formData.append("alt", item.alt)
        try {
          const response = await api.uploadWebsiteImage(formData)
          if (response.file) {
            this.studioContent.clubSection.pictures.unshift({
              src: response.file,
              alt: response.alt,
            })
          }
        } catch (error) {
          this.$toast.error(`Fehler beim Hochladen von: ${item.file.name}`)
        }
      }
      this.$toast.success(`${this.uploadItems.length} Bild(er) erfolgreich hochgeladen`)
      this.uploadItems = []
      this.imageFiles = []
      this.isUploadingImages = false
    },
    removePicture(index) {
      this.studioContent.clubSection.pictures.splice(index, 1)
    },
  },
  // NEU: Gibt die Object-URLs frei, um Memory-Leaks zu verhindern
  beforeDestroy() {
    this.uploadItems.forEach((item) => URL.revokeObjectURL(item.preview))
  },
}
</script>

<style scoped>
/* Unveränderte Styles */
.video-container {
  position: relative;
  width: 100%;
  background-color: #000;
  border-radius: 4px;
}
video {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.drag-handle {
  cursor: grab;
}
.ghost {
  opacity: 0.5;
  background: #2a2a2a;
}
.flip-list-move {
  transition: transform 0.5s;
}
</style>
